/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AuthenticateResult } from '../models/AuthenticateResult';
import type { AuthenticateUser } from '../models/AuthenticateUser';
import type { CreateUserRequest } from '../models/CreateUserRequest';
import type { CreateUserResult } from '../models/CreateUserResult';
import type { ResetUserRequest } from '../models/ResetUserRequest';
import type { ResetUserResponse } from '../models/ResetUserResponse';
import type { UserExistsResponse } from '../models/UserExistsResponse';
import type { UserInfo } from '../models/UserInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class UserService {

    /**
     * @param email
     * @returns UserExistsResponse User exists
     * @throws ApiError
     */
    public static userExists(
        email: string,
    ): CancelablePromise<UserExistsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user/exists',
            query: {
                'email': email,
            },
            errors: {
                403: `Unauthorized`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns CreateUserResult The created user
     * @throws ApiError
     */
    public static createUser(
        requestBody: CreateUserRequest,
    ): CancelablePromise<CreateUserResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/user/create',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                403: `Unauthorized`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns AuthenticateResult Ok
     * @throws ApiError
     */
    public static authenticateUser(
        requestBody: AuthenticateUser,
    ): CancelablePromise<AuthenticateResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/user/login',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                422: `Unprocessable Entity`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns ResetUserResponse Success
     * @throws ApiError
     */
    public static resetUser(
        requestBody: ResetUserRequest,
    ): CancelablePromise<ResetUserResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/user/reset',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                403: `Unauthorized`,
            },
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public static logout(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/user/logout',
        });
    }

    /**
     * @returns UserInfo Logged in user
     * @throws ApiError
     */
    public static getMe(): CancelablePromise<UserInfo> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/me',
            errors: {
                403: `Unauthorized`,
            },
        });
    }

}
